import React from "react";
import {
    Paper,
    IconButton,
    Dialog,
    Typography
} from "@mui/material";
import DOMPurify from 'dompurify';
import { useGlobalModalContext } from "../context/GlobalModalContext";
import CodeIcon from '@mui/icons-material/Code';
import TableViewIcon from '@mui/icons-material/TableView';
import ChartsDataTable from "./ChartsDataTable";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coy } from "react-syntax-highlighter/dist/esm/styles/prism";

function ChatbotTextResponse({ html, sqlCode, chartsData, timestamp }) {
    const [value, setValue] = React.useState('');
    const { showModal, hideModal } = useGlobalModalContext();
    const sqlIcon = '</>'

    const handleTableView = () => {
        showModal(
            <Dialog open onClose={hideModal} maxWidth={false} // Allows the dialog to exceed default size limits
                sx={{
                    '& .MuiPaper-root': {
                        minWidth: '600px', // Ensure minimum width
                        maxWidth: '90vw',  // Prevent exceeding viewport width
                    },
                }}>
                <ChartsDataTable chartsData={chartsData} />
            </Dialog>
        )
    }
    const handleShowSQL = () => {
        const sqlMatch = sqlCode.match(/SQL Query:\s*\n\n([\s\S]*?)\n\nChart JSON:/);
        const sqlQuery = sqlMatch ? sqlMatch[1] : "SQL Query not found.";

        const handleCopy = () => {
            navigator.clipboard.writeText(sqlQuery);
            alert("SQL query copied to clipboard!");
        };

        showModal(
            <Dialog open onClose={hideModal} maxWidth="md">
                <div className="mx-4">
                    <SyntaxHighlighter language="sql" style={coy} wrapLines>
                        {sqlCode.trim()}
                    </SyntaxHighlighter>
                    <button
                        className="copy-button"
                        onClick={handleCopy}
                        style={{
                            marginTop: "10px",
                            padding: "8px 16px",
                            backgroundColor: "#f0f4f8",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    >
                        Copy Query
                    </button>
                </div>
            </Dialog>
        )
    };

    return (
        <Paper
            sx={{
                p: 2,
                mb: 1,
                backgroundColor: "#e8eaf6",
                borderRadius: "8px",
            }}

        >
            <>
                <div className="flex justify-between align-center">
                    {/* Timestamp */}
                    <Typography
                        variant="caption"
                        sx={{ textAlign: "left", mt: 1.5, fontWeight: '600' }}
                    >
                        {timestamp}
                    </Typography>
                    <div className="flex justify-end">
                        {/* <IconButton aria-label="<>" onClick={handleTableView}>
                            <TableViewIcon />
                        </IconButton>
                        <IconButton aria-label="<>" onClick={handleShowSQL}>
                            <CodeIcon />
                        </IconButton> */}
                    </div>
                </div>

                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}></div>
            </>
        </Paper>
    );
}

export default ChatbotTextResponse;
